export default __webpack_public_path__ + "static/media/dermus_icon.6b5d48c2.png";